<p-confirmDialog key="stationblockalertedit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Options-->
<div class="ItemBorder">
	<h4 style="text-align: center">Options:</h4>
	<div class="MainGrid2Col">
		<label>School:</label>
		<label class="InfoText">{{ SchoolName }}</label>

		<label>Message:</label>
		<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Message" maxlength="100" />

		<label>Date Range:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DateRangeID" [(ngModel)]="DateRangeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDateRange" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label *ngIf="DateRangeID == 2 || DateRangeID == 3">Start Date:</label>
		<p-calendar
			*ngIf="DateRangeID == 2 || DateRangeID == 3"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			appendTo="body"
		></p-calendar>

		<label *ngIf="DateRangeID == 2 || DateRangeID == 4">End Date:</label>
		<p-calendar
			*ngIf="DateRangeID == 2 || DateRangeID == 4"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			appendTo="body"
		></p-calendar>

		<label>Time Range:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="TimeRangeID" [(ngModel)]="TimeRangeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstTimeRange" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label *ngIf="TimeRangeID == 2 || TimeRangeID == 3">Start Time:</label>
		<p-calendar
			*ngIf="TimeRangeID == 2 || TimeRangeID == 3"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="StartTime"
			name="StartTime"
			appendTo="body"
		></p-calendar>

		<label *ngIf="TimeRangeID == 2 || TimeRangeID == 4">End Time:</label>
		<p-calendar
			*ngIf="TimeRangeID == 2 || TimeRangeID == 4"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="EndTime"
			name="EndTime"
			appendTo="body"
		></p-calendar>

		<label>Priority:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="PriorityID" [(ngModel)]="PriorityID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPriority" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Active:</label>
		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="Active" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
